<template>
  <nav class="navbar navbar-expand-lg sticky-top" v-if="!bookingAppointment">
    <div class="container-fluid">
      <RouterLink class="navbar-brand" to="/">So-Well Prepared Tax Prep</RouterLink>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarScroll"
        aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarScroll">
        <ul class="navbar-nav me-auto my-2 my-lg-0">
          <li class="nav-item">
            <RouterLink class="router-link" active-class="active-btn" to="/">Profile
            </RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink class="router-link" active-class="active-btn" to="/services">Services
            </RouterLink>
          </li>
          <li class="nav-item">
          </li>
          <li class="nav-item">
            <a class="router-link" href="#contact">Contact
            </a>
          </li>
        </ul>
        <a class="router-link-appointment router-link-navbar" href="http://booking.sowellprepared.org">
          Make An Appointment
        </a>
      </div>
    </div>
  </nav>
  <main>
    <RouterView />
  </main>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {

    }
  }
}
</script>

<style>
#app {
  background: linear-gradient(135deg, #ff99cc, #66b2ff);
  background-size: cover;
  min-height: 100vh;
  overflow-x: hidden;
}

.router-link {
  color: white;
  text-decoration: none;
  margin-right: 0.75rem;
  padding: 0.5rem;
  font-size: 1.15rem
}

.router-link:hover {
  color: #66b2ff
}

.router-link-appointment {
  background: #66b2ff;
  color: white;
  text-decoration: none;
  padding: 0.5rem;
  border-radius: 7.5px
}

.navbar-brand,
.navbar-brand:hover {
  color: #f0f0f0;
  font-size: 2.5rem;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.active-btn {
  background-color: white;
  color: #66b2ff;
  border-color: white;
  border-radius: 7.5px;
}

@media(max-width: 1200px) and (min-width: 992px) {
  .navbar-brand {
    font-size: 2.25rem;
  }
}

@media(max-width: 992px) and (min-width: 768px) {
  .navbar-brand {
    font-size: 2.2rem;
  }

  .navbar li {
    margin-bottom: 0.1rem;
  }

  .active-btn {
    margin-bottom: 0.2rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 300px
  }
}

@media(max-width: 768px) and (min-width: 576px) {
  .navbar-brand {
    font-size: 2rem;
  }

  .navbar li {
    margin-bottom: 0.1rem;
  }

  .active-btn {
    margin-bottom: 0.2rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 300px;
    font-size: 1.1rem
  }
}

@media(max-width: 576px) and (min-width: 420px) {
  .navbar-brand {
    font-size: 1.75rem;
  }

  .navbar li {
    margin-bottom: 0.05rem;
  }

  .active-btn {
    margin-bottom: 0.1rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 250px;
    font-size: 1.05rem;
    padding: 0.35rem;
  }
}

@media(max-width: 420px) and (min-width: 360px) {
  .navbar-brand {
    font-size: 1.35rem;
  }

  .navbar li {
    margin-bottom: 0.05rem;
  }

  .active-btn {
    margin-bottom: 0.1rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 225px;
    font-size: 0.95rem;
    padding: 0.35rem;
  }
}

@media(max-width: 360px) {
  .navbar-brand {
    font-size: 1.15rem;
  }

  .navbar li {
    margin-bottom: 0.05rem;
  }

  .active-btn {
    margin-bottom: 0.1rem;
  }

  .router-link,
  .router-link-navbar {
    display: block;
    width: 200px;
    font-size: 0.85rem;
    padding: 0.25rem;
  }
}
</style>
